export default __webpack_public_path__ + "static/media/developerActivity.967f31da.svg";